module.exports = __webpack_public_path__ + "static/media/company-logo-9.d565115f.png";